module.exports = __webpack_public_path__ + "static/img/ARAW45-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAW45-1.png
// module id = d/rX
// module chunks = 0